import React from 'react'

import { Portlet, Row, Col, Button } from '_zari/core'
import { ZariContext } from '_zari/context'

import * as FormGroups from './formGroups'

import * as InventarioService from 'services/inventario.service'

import * as Sections from './sections'
import { DownloadAxiosFile } from 'utils'

const ConsultasConsumos = () => {
  const __zariContext = React.useContext(ZariContext)

  const [fechaDesde, setFechaDesde] = React.useState('')
  const [fechaHasta, setFechaHasta] = React.useState('')
  const [multiAlmacenCheck, setMulitAlmacenCheck] = React.useState(false)
  const [todosLosProductosCheck, setTodosLosProductosCheck] = React.useState(true)
  const [flagPorProducto, setFlagPorProducto] = React.useState(true)
  const [flagPorCosto, setFlagPorCosto] = React.useState(false)
  const [productoSeleccionado, setProductoSeleccionado] = React.useState(null)
  const [centroCostoNivel1, setCentroCostoNivel1] = React.useState(null)
  const [centroCostoNivel2, setCentroCostoNivel2] = React.useState(null)
  const [sectionData, setSectionData] = React.useState(null)

  const clickVerInforme = React.useCallback(() => {
    let idProducto = productoSeleccionado ? productoSeleccionado._id : null
    if (!fechaDesde || !fechaHasta) {
      __zariContext.snack('error', 'El campo fecha es requerido')
    } else if (flagPorCosto && (!centroCostoNivel1 || !centroCostoNivel2)) {
      __zariContext.snack('error', 'El campo centro costo es requerido')
    } else if (flagPorProducto && !todosLosProductosCheck && !productoSeleccionado) {
      __zariContext.snack('error', 'El campo producto es requerido')
    } else {
      InventarioService.obtenerConsultaConsumosAsTable({
        fechaDesde,
        fechaHasta,
        multiAlmacenCheck,
        todosLosProductosCheck,
        flagPorProducto,
        flagPorCosto,
        idProducto,
        centroCostoNivel1,
        centroCostoNivel2
      }).then(({ data }) => {
        setSectionData({
          ...data,
          fechaDesde,
          fechaHasta,
          multiAlmacenCheck,
          todosLosProductosCheck,
          flagPorProducto,
          flagPorCosto,
          idProducto,
          centroCostoNivel1,
          centroCostoNivel2
        })
      })
    }
  }, [
    fechaDesde,
    fechaHasta,
    multiAlmacenCheck,
    todosLosProductosCheck,
    flagPorProducto,
    flagPorCosto,
    productoSeleccionado,
    centroCostoNivel1,
    centroCostoNivel2,
    __zariContext
  ])

  const clickDescargarExcel = React.useCallback(() => {
    let idProducto = productoSeleccionado ? productoSeleccionado._id : null
    if (!fechaDesde || !fechaHasta) {
      __zariContext.snack('error', 'El campo fecha es requerido')
    } else if (flagPorCosto && (!centroCostoNivel1 || !centroCostoNivel2)) {
      __zariContext.snack('error', 'El campo centro costo es requerido')
    } else if (flagPorProducto && !todosLosProductosCheck && !productoSeleccionado) {
      __zariContext.snack('error', 'El campo producto es requerido')
    } else {
      __zariContext.loader.open('Descargando Consulta Consumos...')
      InventarioService.descargarExcelConsultaConsumos({
        fechaDesde,
        fechaHasta,
        multiAlmacenCheck,
        todosLosProductosCheck,
        flagPorProducto,
        flagPorCosto,
        idProducto,
        centroCostoNivel1,
        centroCostoNivel2
      })
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
        })
    }
  }, [
    fechaDesde,
    fechaHasta,
    multiAlmacenCheck,
    todosLosProductosCheck,
    flagPorProducto,
    flagPorCosto,
    productoSeleccionado,
    centroCostoNivel1,
    centroCostoNivel2,
    __zariContext
  ])

  const limpiarTabla = React.useCallback(() => {
    setSectionData(null)
  }, [])

  return (
    <>
      <Row>
        <Col md={6}>
          <Portlet>
            <Portlet.Header title='CONSULTAS CONSUMOS' />
            <Portlet.Body>
              <Row>
                <Col md={12}>
                  <Row className='mb-3'>
                    <Col md={5}>
                      <FormGroups.FechaFormGroup
                        text='Desde'
                        value={fechaDesde}
                        handleChange={e => {
                          setFechaDesde(e.target.value)
                          limpiarTabla()
                        }}
                      />
                    </Col>
                    <Col md={5}>
                      <FormGroups.FechaFormGroup
                        text='Hasta'
                        value={fechaHasta}
                        handleChange={e => {
                          setFechaHasta(e.target.value)
                          limpiarTabla()
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className='mb-3'>
                    <Col md={5}>
                      <FormGroups.CheckBoxFormGroup
                        text='Multi Almacen'
                        value={multiAlmacenCheck}
                        handleChange={() => {
                          setMulitAlmacenCheck(prev => !prev)
                          limpiarTabla()
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className='mb-3'>
                    <Col md={5}>
                      <FormGroups.TipoConsultaFormGroup
                        text='Por productos'
                        value={flagPorProducto}
                        handleChange={() => {
                          setFlagPorCosto(false)
                          setFlagPorProducto(true)
                          setCentroCostoNivel1(null)
                          setCentroCostoNivel2(null)
                          limpiarTabla()
                        }}
                      />
                    </Col>
                    <Col md={5}>
                      <FormGroups.TipoConsultaFormGroup
                        text='Por costos'
                        value={flagPorCosto}
                        handleChange={() => {
                          setFlagPorProducto(false)
                          setFlagPorCosto(true)
                          setTodosLosProductosCheck(true)
                          setProductoSeleccionado(null)
                          limpiarTabla()
                        }}
                      />
                    </Col>
                  </Row>
                  {flagPorProducto ? (
                    <>
                      <Row className='mb-3'>
                        <Col md={12}>
                          <FormGroups.CheckBoxFormGroup
                            text='Todos los productos'
                            value={todosLosProductosCheck}
                            handleChange={() => {
                              setTodosLosProductosCheck(prev => !prev)
                              setProductoSeleccionado(null)
                              limpiarTabla()
                            }}
                          />
                        </Col>
                      </Row>
                      {!todosLosProductosCheck && (
                        <Row className='mb-3'>
                          <Col md={12}>
                            <FormGroups.ProductosFormGroup
                              value={productoSeleccionado}
                              setValue={setProductoSeleccionado}
                              limpiarTabla={limpiarTabla}
                            />
                          </Col>
                        </Row>
                      )}
                    </>
                  ) : (
                    <>
                      <Row className='mb-3'>
                        <Col md={12}>
                          <FormGroups.CentrosCosto1FormGroup
                            value={centroCostoNivel1}
                            setValue={setCentroCostoNivel1}
                            limpiarTabla={limpiarTabla}
                          />
                        </Col>
                      </Row>
                      {centroCostoNivel1 && (
                        <Row>
                          <Col md={12}>
                            <FormGroups.CentrosCosto2FormGroup
                              value={centroCostoNivel2}
                              setValue={setCentroCostoNivel2}
                              valueNivel1={centroCostoNivel1}
                              limpiarTabla={limpiarTabla}
                            />
                          </Col>
                        </Row>
                      )}
                    </>
                  )}
                  <Row>
                    <Col md={12} className='text-right'>
                      <Button onClick={clickVerInforme}>Ver Pantalla</Button>
                      <Button onClick={clickDescargarExcel}>Descargar Excel</Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Portlet.Body>
          </Portlet>
        </Col>
      </Row>
      {sectionData !== null && (
        <Row>
          <Sections.TablaConsumosSection sectionData={sectionData} />
        </Row>
      )}
    </>
  )
}

export default React.memo(ConsultasConsumos)
